/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, ReplaySubject} from 'rxjs';
import {FeatureToggleService} from './feature-toggle.service';
import {ErrorPageEnum} from '../../error-page/error-page.enum';
import {DependencyLoadNotifierService} from '../../services/dependency-load-notifier/dependency-load-notifier.service';

@Injectable({
    providedIn: 'root'
})
export class FeatureToggleGuard  {
    canActivateChild = this.canActivate;

    constructor(private featureToggle: FeatureToggleService,
                private dependencyLoadNotifier: DependencyLoadNotifierService,
                private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
        const featureToggles: string[] = next?.data?.featureToggles ?? [];
        const isAllowedSubject = new ReplaySubject<boolean>(1);

        this.dependencyLoadNotifier.onReady.subscribe(() => {
            const canNavigate = this.featureToggle.isEnabled(featureToggles);

            if (!canNavigate) {
                // In reality, this should be something like this:
                // this.router.navigate(['/', 'error'], {queryParams: {errorType: ErrorPageEnum.NOT_FOUND}});
                // Since we don't have a "not found" page yet, we'll redirect the user to the homepage
                this.router.navigate(['/']);
            }

            isAllowedSubject.next(canNavigate);
            isAllowedSubject.complete();
        });

        return isAllowedSubject.asObservable();
    }
}
